import { router } from "@inertiajs/react";
import {
  actions_bizminer_app_pillar_insight_improvement_lever_path,
  deep_dive_bizminer_app_pillar_insight_improvement_lever_path,
  overview_bizminer_app_pillar_insight_improvement_lever_path,
} from "@/routes";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";

interface ImprovementLeverTabsProps {
  currentTab: string;
  pillarInsightId: number;
  improvementLeverId: number;
}

export function ImprovementLeverTabs({
  currentTab,
  pillarInsightId,
  improvementLeverId,
}: ImprovementLeverTabsProps) {
  const tabs = [
    { value: "overview", label: "Summary" },
    { value: "deep_dive", label: "Deep Dive" },
    { value: "actions", label: "Actions" },
  ];

  const handleTabChange = (value: string) => {
    let path: string;

    switch (value) {
      case "overview":
        path = overview_bizminer_app_pillar_insight_improvement_lever_path(
          pillarInsightId,
          improvementLeverId,
        );
        break;
      case "deep_dive":
        path = deep_dive_bizminer_app_pillar_insight_improvement_lever_path(
          pillarInsightId,
          improvementLeverId,
        );
        break;
      case "actions":
        path = actions_bizminer_app_pillar_insight_improvement_lever_path(
          pillarInsightId,
          improvementLeverId,
        );
        break;
      default:
        return;
    }

    router.visit(path, {
      preserveScroll: true,
      preserveState: false,
      replace: false,
    });
  };

  return (
    <Tabs value={currentTab} onValueChange={handleTabChange}>
      <TabsList>
        {tabs.map((tab) => (
          <TabsTrigger key={tab.value} value={tab.value}>
            {tab.label}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
}
